import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {IconDefinition} from "@fortawesome/free-solid-svg-icons";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup} from "@angular/forms";
import {AntragstellerEmbeddedDTO} from "../../../../models/antrag-ticket/AntragstellerEmbeddedDTO";
import {KeyString} from "../../../../models/textbaustein/KeyString";
import {Land} from "../../../../models/land/Land";
import {InputComponent} from "../../../../shared/form/input/input.component";

@Component({
    selector: 'app-antragsteller-card',
    imports: [
        FaIconComponent,
        FormsModule,
        ReactiveFormsModule,
        TranslatePipe,
        InputComponent
    ],
    templateUrl: './antragsteller-card.component.html',
    styleUrl: './antragsteller-card.component.scss'
})
export class AntragstellerCardComponent implements OnChanges {

  @Input() icon: IconDefinition = undefined;
  @Input() title: string = this.translateService.instant('STANDARD.ANTRAGSTELLER');
  @Input() description: string = undefined;

  @Input() antragsteller : AntragstellerEmbeddedDTO = {} as AntragstellerEmbeddedDTO;

  antragstellerForm : UntypedFormGroup = undefined;

  constructor(
    private readonly translateService: TranslateService,
    private readonly fb: UntypedFormBuilder,
  ) {
    this.initForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.antragsteller && changes.antragsteller.currentValue){
      const dto : AntragstellerEmbeddedDTO = changes.antragsteller.currentValue;
      this.antragstellerForm.patchValue({
        nachname: dto.personDto?.nachname,
        vorname: dto.personDto?.vorname,
        geburtsdatum: dto.personDto?.geburtsdatum,
        email: dto.personDto?.email,
        strasse: dto.adresseDto?.strasse,
        adresszusatz: dto.adresseDto?.adresszusatz,
        plz: dto.adresseDto?.plz,
        ort: dto.adresseDto?.ort,
        land: (Land as any)[dto.adresseDto.land]
      });
    }
  }

  initForm(){
    this.antragstellerForm = this.fb.group({
      nachname: undefined,
      vorname: undefined,
      geburtsdatum: undefined,
      email: undefined,
      strasse: undefined,
      plz: undefined,
      ort: undefined,
      land: undefined,
      adresszusatz: undefined,
    });
  }

  protected readonly KeyString = KeyString;
}
